import { render, staticRenderFns } from "./editMenu.vue?vue&type=template&id=3504a6ca&scoped=true"
import script from "./editMenu.vue?vue&type=script&lang=ts"
export * from "./editMenu.vue?vue&type=script&lang=ts"
import style0 from "./editMenu.vue?vue&type=style&index=0&id=3504a6ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3504a6ca",
  null
  
)

export default component.exports